export default {
  questions: [
    {
      order: 1,
      title: 'Indica el producto más sofisticado en el cual has invertido.',
      answers: [
        {
          order: 1,
          value: 1,
          title: 'Lorem ipsum',
        },
        {
          order: 2,
          value: 2,
          title: 'Vivamus placerat',
        },
        {
          order: 3,
          value: 3,
          title: 'Aenean id',
        },
      ],
    },
    {
      order: 2,
      title: 'Indica el producto más sofisticado en el cual has invertido.',
      answers: [
        {
          order: 1,
          value: 1,
          title: 'Lorem ipsum',
        },
        {
          order: 2,
          value: 2,
          title: 'Vivamus placerat',
        },
        {
          order: 3,
          value: 3,
          title: 'Aenean id',
        },
      ],
    },
    {
      order: 3,
      title: 'Indica el producto más sofisticado en el cual has invertido.',
      answers: [
        {
          order: 1,
          value: 1,
          title: 'Lorem ipsum',
        },
        {
          order: 2,
          value: 2,
          title: 'Vivamus placerat',
        },
        {
          order: 3,
          value: 3,
          title: 'Aenean id',
        },
      ],
    },
    {
      order: 4,
      title: 'Indica el producto más sofisticado en el cual has invertido.',
      answers: [
        {
          order: 1,
          value: 1,
          title: 'Lorem ipsum',
        },
        {
          order: 2,
          value: 2,
          title: 'Vivamus placerat',
        },
        {
          order: 3,
          value: 3,
          title: 'Aenean id',
        },
      ],
    },
    {
      order: 5,
      title: 'Indica el producto más sofisticado en el cual has invertido.',
      answers: [
        {
          order: 1,
          value: 1,
          title: 'Lorem ipsum',
        },
        {
          order: 2,
          value: 2,
          title: 'Vivamus placerat',
        },
        {
          order: 3,
          value: 3,
          title: 'Aenean id',
        },
      ],
    },
    {
      order: 6,
      title: 'Indica el producto más sofisticado en el cual has invertido.',
      answers: [
        {
          order: 1,
          value: 1,
          title: 'Lorem ipsum',
        },
        {
          order: 2,
          value: 2,
          title: 'Vivamus placerat',
        },
        {
          order: 3,
          value: 3,
          title: 'Aenean id',
        },
      ],
    },
    {
      order: 7,
      title: 'Indica el producto más sofisticado en el cual has invertido.',
      answers: [
        {
          order: 1,
          value: 1,
          title: 'Lorem ipsum',
        },
        {
          order: 2,
          value: 2,
          title: 'Vivamus placerat',
        },
        {
          order: 3,
          value: 3,
          title: 'Aenean id',
        },
      ],
    },
    {
      order: 8,
      title: 'Indica el producto más sofisticado en el cual has invertido.',
      answers: [
        {
          order: 1,
          value: 1,
          title: 'Lorem ipsum',
        },
        {
          order: 2,
          value: 2,
          title: 'Vivamus placerat',
        },
        {
          order: 3,
          value: 3,
          title: 'Aenean id',
        },
      ],
    },
    {
      order: 9,
      title: 'Indica el producto más sofisticado en el cual has invertido.',
      answers: [
        {
          order: 1,
          value: 1,
          title: 'Lorem ipsum',
        },
        {
          order: 2,
          value: 2,
          title: 'Vivamus placerat',
        },
        {
          order: 3,
          value: 3,
          title: 'Aenean id',
        },
      ],
    },
    {
      order: 10,
      title: 'Indica el producto más sofisticado en el cual has invertido.',
      answers: [
        {
          order: 1,
          value: 1,
          title: 'Lorem ipsum',
        },
        {
          order: 2,
          value: 2,
          title: 'Vivamus placerat',
        },
        {
          order: 3,
          value: 3,
          title: 'Aenean id',
        },
      ],
    },
  ],
  profiles: [
    {
      name: 'Inversionista Conservador',
      description:
        'Cras facilisis diam in ante vehicula, eu hendrerit lorem posuere. Maecenas dignissim mattis tempus. Lorem ipsum dolor sit amet.',
      range: {
        min: 10,
        max: 15,
      },
    },
    {
      name: 'Inversionista Moderado',
      description:
        'Cras facilisis diam in ante vehicula, eu hendrerit lorem posuere. Maecenas dignissim mattis tempus. Lorem ipsum dolor sit amet.',
      range: {
        min: 16,
        max: 24,
      },
    },
    {
      name: 'Inversionista Agresivo',
      description:
        'Cras facilisis diam in ante vehicula, eu hendrerit lorem posuere. Maecenas dignissim mattis tempus. Lorem ipsum dolor sit amet.',
      range: {
        min: 25,
        max: 30,
      },
    },
  ],
};
